module.exports = __webpack_public_path__ + "static/media/ic_grab.1e3623c8.svg";